import { useTranslation } from '../../../lib/i18n';
import { autoApproveLine, autoApproveTime } from '../../../lib/auto-approve-line';
import { useAutoApproveScheduledPosts } from '../../settings/shared/use-notification-settings';

/**
 * "Goes out {time} unless you change it" / "Won't go out unless you approve" (`lib/auto-approve-line.ts`). Rendered
 * only for a question that carries an auto-approve choice, so the settings read it needs happens only for those.
 */
export function AutoApproveLineText({
  choice,
  dueBy,
  postAt,
  className,
  testId,
}: {
  choice: string;
  dueBy?: string;
  postAt?: string;
  className?: string;
  testId?: string;
}) {
  const { t, i18n } = useTranslation();
  const on = useAutoApproveScheduledPosts(true);
  const line = autoApproveLine({ autoApproveChoice: choice, dueBy }, postAt, on);
  if (!line) return null;
  const text =
    line.key === 'tasks.decision.autoApprove.goesOut'
      ? t(line.key, { time: autoApproveTime(line.at, new Date(), i18n.language || undefined) })
      : t(line.key);
  return (
    <p className={className} data-testid={testId}>
      {text}
    </p>
  );
}
